import { render, staticRenderFns } from "./customerCredit.vue?vue&type=template&id=88dd8758&scoped=true"
import script from "./customerCredit.vue?vue&type=script&lang=js"
export * from "./customerCredit.vue?vue&type=script&lang=js"
import style0 from "./customerCredit.vue?vue&type=style&index=0&id=88dd8758&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dd8758",
  null
  
)

export default component.exports